import { BrowserRouter as Router } from 'react-router-dom';

import { AuthProvider } from './context/AuthProvider';
import { DictionaryProvider } from './context/DictionaryProvider';
import { ViewportProvider } from './context/ViewportProvider';
import { PageProvider } from './context/PageProvider';
import PDThemeProvider from './components/PDThemeProvider';
import AccessibilityWidget from './components/AccessibilityWidget';

import RoutesWrapper from './RoutesWrapper';

function App() {
    return (
        <Router>
            <AuthProvider>
                <PageProvider>
                    <DictionaryProvider>
                        <ViewportProvider>
                            <PDThemeProvider>
                                <AccessibilityWidget />
                                <RoutesWrapper />
                            </PDThemeProvider>
                        </ViewportProvider>
                    </DictionaryProvider>
                </PageProvider>
            </AuthProvider>
        </Router>
    );
}

export default App;
